import { customIconMap, lucideIconsMap, type NoddiIconName } from 'noddi-ui-common';
import { SALES_ITEM_TAG_ICON_TO_NODDI_ICON } from 'noddi-util';

const isNoddiIconName = (name: string): name is NoddiIconName => name in lucideIconsMap || name in customIconMap;

/**
 * Maps a backend `SalesItemTagIcon` value (SNAKE_CASE) to the icon the design system knows.
 * The parameter is `string` because nsdk types `icon` as `string | null` on every writable
 * `SalesItemTagRecord*`; only the nested `*Minimal` records carry the `SalesItemTagIcon` union.
 * This is the one place an unknown value is rejected.
 */
export const salesItemTagIcon = (icon: string | null | undefined): NoddiIconName | null => {
  if (!icon) {
    return null;
  }

  const noddiIconName = SALES_ITEM_TAG_ICON_TO_NODDI_ICON[icon];

  return noddiIconName && isNoddiIconName(noddiIconName) ? noddiIconName : null;
};
